export const HUBSPOT_INTEGRATION = 'hubspot'
export const HUBSPOT_CALLING_INTEGRATION = 'hubspot-calling'
export const PIPEDRIVE_INTEGRATION = 'pipedrive'
export const ZOHO_INTEGRATION = 'zoho'
export const SALESFORCE_INTEGRATION = 'salesforce'
export const GUESTY_INTEGRATION = 'guesty'
export const GOHIGHLEVEL_INTEGRATION = 'gohighlevel'
